import { tickerItems } from '@/mocks/site';

export default function TickerBar() {
  const items = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-primary-600 text-background-50 overflow-hidden">
      <div className="flex items-center">
        <span className="shrink-0 flex items-center gap-2 px-4 md:px-6 py-2.5 bg-primary-700 text-xs font-medium whitespace-nowrap z-10">
          <i className="ri-notification-3-line"></i>
          站内快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            {items.map((item, i) => (
              <span key={`${item}-${i}`} className="flex items-center gap-3 px-6 py-2.5 text-xs text-background-100 whitespace-nowrap">
                <i className="ri-film-line text-accent-300"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}